import { useParams, useNavigate } from 'react-router-dom'
import { useFetchOrder } from '../../hooks/useFetchOrder'
import { toPersianDateTime } from '../../utils/gmt-to-local-persian-date'
import { InvoiceSummary } from '../Cart/InvoiceSummary'
import { ReceiverInfo } from '../Cart/ReceiverInfo'
import { OrderReportList } from './OrderReportList'
import { ProductsListSkeleton } from '../../ui/ProductsListSkelton'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { makeNumbersFarsi } from 'utils/farsi'

interface OrderStatusTypes {
  checkout?: string
  'payment-succeed'?: string
  'partially-fulfilled'?: string
  fulfilled?: string
  'partially-shipped'?: string
  shipped?: string
  completed?: string
  declined?: string
}

const STATUS_LITERALS = {
  checkout: 'پرداخت نشده',
  'payment-succeed': 'در حال پردازش و بسته‌بندی',
  'partially-fulfilled': 'بخشی از سفارش پردازش شد',
  fulfilled: 'آماده‌ی ارسال',
  'partially-shipped': 'بخشی از سفارش ارسال شد',
  shipped: 'ارسال شد',
  completed: 'دریافت شده توسط گیرنده',
  declined: 'رد شد',
}

export const OrderDetails = () => {
  const { orderId } = useParams()
  const navigate = useNavigate()
  const { order, isLoading, isError, error } = useFetchOrder(orderId)
  let status = order?.items[0].status

  let paymentSucceedStatusChange = order?.statusHistory.find(
    (item) => (item.status = 'payment-succeed'),
  )
  const changedAt = paymentSucceedStatusChange?.changedAt
  let paymentSucceedDate = new Date(changedAt as number)
  const handleBackButtonClick = () => {
    navigate('/orders')
  }

  useEffect(() => {
    if (status === 'payment-succeed') {
      // Clear localStorage if payment is successful
      localStorage.removeItem('cart')
      window.dispatchEvent(new Event('cart-changed'))
    }
  }, [status])

  return (
    <div className='container mx-auto my-10 h-auto border p-4 rounded-md bg-[#81a1c1] text-white'>
      <Helmet>
        <title className='text-xl font-semibold font-semibold'>
          {` جزئیات سفارش ${order?.id.split('-')[0]}`}
        </title>
        <meta
          name='description'
          content='بوک استوری - هر کتاب یک داستان، هر داستان یک زندگی دوباره'
        />
      </Helmet>
      <button
        className='bg-[#5E81AC] rounded border-none w-full mb-4 p-4 text-white cursor-pointer lg:hidden'
        onClick={handleBackButtonClick}
      >
        بازگشت به سفارشات
      </button>
      {isLoading && (
        <div className='mt-3'>
          <ProductsListSkeleton />
        </div>
      )}{' '}
      {isError && <h1>{isError && error?.message}</h1>}
      {status === 'payment-succeed' ? (
        <div className='text-white text-lg font-semibold p-4 my-3 border-b-2'>
          <h2>سفارش {order?.id.split('-')[0]} با موفقیت پرداخت و ثبت گردید.</h2>
          <h4>پرداخت با موفقیت انجام شد و به زودی برایتان ارسال خواهد شد.</h4>
          <h4>از اینکه بوک استوری را برای خرید انتخاب کرده اید متشکریم.</h4>
        </div>
      ) : null}
      <div className='flex flex-col border-b-2'>
        <h2 className='p-4 text-xl font-bold'>
          جزئیات سفارش با کد {order?.id.split('-')[0]}
        </h2>
        <div className='text-lg font-semibold p-4 my-3'>
          <div className='my-2'>
            <strong>زمان پرداخت و ثبت سفارش: </strong>
            {toPersianDateTime(paymentSucceedDate)}
          </div>

          <div className='my-2'>
            <strong>آخرین وضعیت: </strong>
            {STATUS_LITERALS[status as keyof OrderStatusTypes]}
          </div>
          {order?.shipmentTrackingCode && (
            <div className='my-4'>
              <strong>کد رهگیری پستی: </strong>
              {makeNumbersFarsi(order.shipmentTrackingCode)}
            </div>
          )}
        </div>
      </div>
      {order && (
        <div className='my-4 border-b-2'>
          <h3 className='p-4 text-xl font-bold'>مشخصات گیرنده:</h3>
          <div className='text-white text-lg font-semibold px-4 my-2'>
            <ReceiverInfo order={order} />
          </div>
        </div>
      )}
      {order && (
        <div className='my-4'>
          <h3 className='p-5 text-xl font-bold'>لیست اقلام سفارش:</h3>
          <div className='bg-[#81A1C1] text-white text-lg font-semibold p-4 my-3 border-b-2'>
            <OrderReportList order={order} />
          </div>
          <div className='text-lg font-semibold p-5 my-5 flex flex-col items-start'>
            <InvoiceSummary order={order} />
          </div>
        </div>
      )}
    </div>
  )
}
